import { Field, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

export interface contextType {
  currentLang: string;
  currentPage: string;
  datasourceLanguage: string;
  handleBlur: React.FocusEventHandler;
  resetMobileMenu: () => void;
  setIsMobile: React.Dispatch<React.SetStateAction<boolean>>;
  isMobile: boolean;
  setOpenMenu: React.Dispatch<React.SetStateAction<boolean>>;
  openMenu: boolean;
  setCloseMenu: React.Dispatch<React.SetStateAction<boolean>>;
  closeMenu: boolean;
  setOpenSubNav: React.Dispatch<React.SetStateAction<string | null>>;
  openSubNav: string | null;
  setShowFlyout: React.Dispatch<React.SetStateAction<boolean>>;
  openFlyout: boolean;
  setHidden: React.Dispatch<React.SetStateAction<boolean>>;
  hidden: boolean;
}

export type LanguageInfo = {
  code: string;
  name: string;
  nativeName: string;
  shortCode?: string;
};

export type HeaderFields = {
  firstLogo: ImageField;
  firstLogoLink: LinkField;
  secondLogo: ImageField;
  secondLogoLink: LinkField;
  availableTranslations: string;
  homeLink: LinkField;
  homeLinkText: Field<string>;
  primaryNav: PrimaryNavigation;
  utilitySection: UtilitySection;
  currentPage: string;
  currentLanguage: string;
  datasourceLanguage: string;
  utilityNavCustomerTypes: CustomerType[];
  pageLanguages: LanguageInfo[];
};

export type HeaderProps = ComponentProps & {
  fields: HeaderFields;
};

export type FlyOut = {
  userTypeDropdownLabel: Field<string>;
  customerTypes: CustomerType[];
  usernameLabel: Field<string>;
  buttonText: Field<string>;
  errorTextForDropdown: Field<string>;
  errorTextForUsername: Field<string>;
  mobileIcon: ImageField;
  mobileDestination: LinkField;
  mobileDestinationLabel: Field<string>;
};

export type CustomerType = {
  fields: {
    dropdownLabel: Field<string>;
    portalDestinationLink: LinkField;
    forgotPasswordLink: LinkField;
    registerLink: LinkField;
    registerLinkText: Field<string>;
    forgotPasswordShortInstructions: Field<string>;
    forgotPasswordLongInstructions: Field<string>;
  };
};

export type PrimaryNavigation = {
  linkText: Field<string>;
  link: LinkField;
  navSections: NavSections[];
};

export type NavSections = {
  title: Field<string>;
  link: LinkField;
  isDescendant: boolean;
  subNavSections: SubNavSection[];
};

export type SubNavSection = {
  title: Field<string>;
  link: LinkField;
  greySection: Field<boolean>;
  subNavSectionsAndLinks: Array<SubNavLinks | SubNavSection>;
};

export type SubNavLinks = {
  langAttributeValue: Field<string>;
  link: LinkField;
  linkText: Field<string>;
};

export type UtilitySection = {
  utilityLinks: Array<UtilityLinkItem | FlyOut>;
  searchLink: LinkField;
};

export type UtilityLinkItem = {
  linkText: Field<string>;
  link: LinkField;
};

export type LanguageSwitcherProps = {
  currentLanguage: string;
  currentPage: string;
  pageLanguages: LanguageInfo[];
  isMobile?: boolean;
  displayMenu?: boolean;
  displayType?: 'mobile' | 'desktop' | '';
  onClose?: () => void;
};
